import React, { Component } from 'react';
import { Box, Alert, AlertTitle, Button } from '@mui/material';
import { ErrorBoundaryProps, ErrorBoundaryState } from '@features/ocr/types/types';

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('OCR Results Error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3 }}>
          <Alert severity="error" variant="filled">
            <AlertTitle>Error Loading/Processing Data</AlertTitle>
            {this.state.error?.message || 'An unexpected error occurred'}
          </Alert>
          <Button sx={{ mt: 2 }} variant="contained" onClick={() => this.setState({ hasError: false, error: null })}>
            Try Again
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;